var React = require('react');

function Info (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M30.2222 0H1.77778C1.30628 0 0.854097 0.187301 0.520699 0.520699C0.187301 0.854097 0 1.30628 0 1.77778V30.2222C0 30.6937 0.187301 31.1459 0.520699 31.4793C0.854097 31.8127 1.30628 32 1.77778 32H30.2222C30.6937 32 31.1459 31.8127 31.4793 31.4793C31.8127 31.1459 32 30.6937 32 30.2222V1.77778C32 1.30628 31.8127 0.854097 31.4793 0.520699C31.1459 0.187301 30.6937 0 30.2222 0ZM28.4444 28.4444H3.55556V3.55556H28.4444V28.4444Z","fill":"#A1A9B3","key":0}),React.createElement("path",{"d":"M14.2222 7.11108H17.7777V10.6666H14.2222V7.11108ZM14.2222 14.2222H17.7777V24.8889H14.2222V14.2222Z","fill":"#A1A9B3","key":1})]);
}

Info.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Info;

Info.default = Info;
